
import { get } from 'services/api';
import { IContactChannels } from '../interface/contactChannels';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { API_V4_BASE_URL } from 'settings';
import { ReactComponent as WhatsAppIcon } from 'assets/svg/WhatsApp.svg';
import { ReactComponent as TelegramIcon } from 'assets/svg/Telegram.svg';
import NotInterestedIcon from '@material-ui/icons/NotInterested';

export const getContactChannels = async(courseId: number) => {
  const listOfChannels = await get({
    url: `/learner/contacts/${courseId}`,
    baseURL: API_V4_BASE_URL,
  });

  return channelsMapper(listOfChannels.data);
};

const channelsMapper = (list: IContactChannels[]) => {
  const extraProps = [
    {name: 'Whatsapp do produtor', icon: WhatsAppIcon },
    {name: 'Telegram do produtor', icon: TelegramIcon},
    {name: 'E-mail de suporte', icon: MailOutlineIcon},
    {name: 'Grupo de estudos', icon: WhatsAppIcon},
    {name: 'Grupo de avisos', icon: WhatsAppIcon},
    {name: 'Prazos e acessos', icon: WhatsAppIcon},
    {name: 'Canal indisponível', icon: NotInterestedIcon }
  ];

  return list.map(c => {
    return {
      ...c,
      ...extraProps[c.type]
    }
  });
}
